const localization = {
  en: {
    quick_action_title: 'Quick Actions',
    messages: 'Messages',
    locations: 'Locations',
    billPay: 'Pay My Bill',
    supportTicket: 'Support Ticket',
    myHealth: 'My Health'
  },
  es: {
    quick_action_title: 'Acciones Rápidas',
    messages: 'Mensajes',
    locations: 'Ubicaciones',
    billPay: 'Pagar mi factura',
    supportTicket: 'Solicitud de servicio',
    myHealth: 'Mi Salud'
  },
  keyMapping: {
    quick_action_title: 'UFD_Quick_Actions',
    messages: 'UFD_Message_Button',
    locations: 'UFD_Location_Button',
    billPay: 'UFD_Pay_My_Bill_Button',
    supportTicket: 'UFD_Support_Ticket',
    myHealth: 'UFD_My_Health_Button'
  }
}

export default localization
